import { SITE_INTEGRATION_TYPE } from "@shared/common/constant/site";
import { Check } from "lucide-react";
import { twMerge } from "tailwind-merge";

interface IStepIndicatorProps {
  currentStepIndex: number;
  steps: string[];
  className?: string;
}

// step 목록. 식스샵 프로(integrationType=8)일 경우만 추가 정보 스텝 제외
export const getSteps = (integrationType: SITE_INTEGRATION_TYPE | null) => {
  const steps = ["약관동의", "회원 정보", "추가 정보"];
  if (integrationType == 8) {
    // 회원 정보, 추가 정보 스텝 제외
    steps.splice(1, 2);
  }
  return steps;
};
/**
 * Step indicator component
 * steps(타이틀 리스트)와 현재 step을 표시하는 컴포넌트
 *
 * - step 사이사이에는 선이 그어짐
 * - 완료한 step은 파란 배경 + 그림자 + 체크 표시
 * - 현재 step은 파란 배경 + 흰색 텍스트
 * - 남은 step은 흰색 배경 + 파랑 테두리 + 흰색 텍스트
 */
export const StepIndicator = ({
  currentStepIndex,
  steps,
  className,
}: IStepIndicatorProps) => {
  return (
    <div
      className={twMerge(
        "relative flex justify-between items-center w-full box-border gap-12",
        className
      )}
      data-gtm-id="step_indicator"
    >
      {steps.map((step, index) => {
        const isCurrentStep = index === currentStepIndex;
        const isCompletedStep = index < currentStepIndex;
        const isRemainingStep = index > currentStepIndex;

        return (
          <div
            key={step}
            className="relative z-10 flex flex-col items-center justify-center flex-1 select-none"
          >
            <div
              className={twMerge(
                "flex justify-center items-center bg-chartPurple-1 border border-transparent rounded-full w-10 h-10 overflow-visible ",
                isRemainingStep && "bg-white  border-chartPurple-1",
                isCompletedStep &&
                  "ring-4 ring-chartPurple-0 ring-offset-0 border-none"
              )}
            >
              {isCompletedStep ? (
                <div className="flex items-center justify-center w-full h-full rounded-full shadow-[0_0_3px_0_rgba(100,107,252,0.40)]">
                  <Check className="text-white" size={18} />
                </div>
              ) : (
                <span
                  className={twMerge(
                    "text-chartPurple-1 mt-px",
                    isCurrentStep && "text-white"
                  )}
                >
                  {index + 1}
                </span>
              )}
            </div>

            <span
              className={twMerge(
                "text-base mt-3 text-neut-0",
                isCurrentStep && "font-medium",
                isRemainingStep && "text-neut-60"
              )}
            >
              {step}
            </span>
          </div>
        );
      })}
      <div
        className="absolute z-0 h-px top-5 bg-chartPurple-1"
        style={{
          left: `calc(100% / ${steps.length} / 2 )`,
          right: `calc(100% / ${steps.length} / 2 )`,
        }}
      ></div>
    </div>
  );
};
